<template lang="jade">
  section#photos
    ul
      li(v-for="photo in photos")
        img(v-bind:src="photo.image")
    h1#top
      a(data-scroll href="#top") top
</template>

<script>
  export default {
    data () {
      return {
        photos: [
          { image: 'imgs/photos/shasta-blodorn-00001.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00002.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00003.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00004.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00005.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00006.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00007.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00008.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00009.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00010.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00011.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00012.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00013.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00014.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00015.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00016.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00017.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00018.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00019.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00020.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00021.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00022.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00023.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00024.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00025.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00026.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00027.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00028.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00029.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00030.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00031.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00032.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00033.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00034.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00035.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00036.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00037.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00038.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00039.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00040.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00041.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00042.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00043.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00044.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00045.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00046.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00047.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00048.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00049.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00050.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00051.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00052.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00053.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00054.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00055.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00056.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00057.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00058.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00059.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00060.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00061.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00062.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00063.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00064.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00065.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00066.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00067.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00068.jpg' },
          { image: 'imgs/photos/shasta-blodorn-00069.jpg' }
        ]
      }
    }
  }
</script>

<style lang="sass?indentedSyntax">

  @import "../_sass/utilities/_utilities.sass"
    
  section#photos
    display: block
    min-height: 100vh
    width: 100vw
    position: absolute
    top: 0
    left: 0
    z-index: 10
    background-color: $overlay
    ul
      width: 100vw
      padding: 10rem 0
      text-align: center
      li
        position: relative
        margin: 4rem
        display: inline-block
        img
          max-width: 60rem
          height: auto

    h1#top
      position: fixed
      width: 100vw
      bottom: 3rem
      left: 2rem
      text-align: center

</style>


/** WEBPACK FOOTER **
 ** Photos.vue?364e4d31
 **/